import { API_ENDPOINTS } from "../config/api/apiCall";
import { callApi } from "../utils/apiClient";

export const loadMaterialCategoryList = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.MATERIAL_GET_CATEGORY, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadMaterialCode = async (payload) => {
    try {
        // const payload = {

        //     p_companyid: localStorage.getItem('companyid') || 0,
        //     p_plantid: 1,
        // };

        return await callApi(API_ENDPOINTS.MATERIAL_GET_CODE, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadMaterialList = async () => {
    try {
        const payload = {

            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.MATERIAL_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadMaterialDetail = async (payload) => {
    try {
       

        return await callApi(API_ENDPOINTS.MATERIAL_GET_DETAIL, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};

export const loadMaterialShadeList = async () => {
    try {
        const payload = {
            p_companyid: localStorage.getItem('companyid') || 0,
            p_plantid: 1,
        };

        return await callApi(API_ENDPOINTS.MATERIAL_SHADE_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error loading material shade list:", error);
        throw error;
    }
};

export const loadMaterialSubCategoryList = async (payload) => {
    try {      

        return await callApi(API_ENDPOINTS.MATERIAL_SUB_CATEGORY_GET_LIST, 'POST', { 'Content-Type': 'application/json' }, payload);
    } catch (error) {
        console.error("Error saving shift roster:", error);
        throw error;
    }
};